
define('jst!tooltips/_space_nav',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<div class=\'space-nav-tooltip\'><div class=\'text-bold title\'><%= data.name %></div><% if (title){ %><p><%= title %></p><% } %></div>\n');
 });

